.loader {
  display: flex;
  justify-content: center;
  padding: 16px;
}